module.exports = __webpack_public_path__ + "static/media/single-product-03.e4054826.jpg";